import {Vue, Component, Prop} from "vue-property-decorator";
import {className} from "~/lib/helpers/string";

@Component
class HeroLoader extends Vue {

  @Prop({type:Boolean, default:false}) overlayed:boolean;

  render() {
    return (
      <div class={className("hero-loader", {overlayed:this.overlayed})}>
        <div class="loader" />
      </div>
    );
  }
}

export default HeroLoader;

// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7215ad90/hero-loader.tsx" });